export default __webpack_public_path__ + "static/im_bg_cta-8dd7e356982f2d7d951f806dbe563cba.png";